import{m as n}from"./chunk-HBP5N4FR.js";n();var s=({amount:i,usd:o,decimals:t=2})=>{let r=(parseFloat(i)*o).toFixed(t);return parseFloat(r).toLocaleString("en",{maximumFractionDigits:t,minimumFractionDigits:t})};export{s as a};
//# sourceMappingURL=chunk-IYB4FZWH.js.map
